import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '../../../services/webSiteUsers/webSiteUsers.service';
import { PdvService } from '../../../services/pdv/pdv.service';
import { localStorageService } from '@app/services/localStorage/localStorage.service';
import { AuthService } from '@app/modules/angular-6-social-login-master';

@Component({
    selector: 'signin',
    templateUrl: 'signin.component.html',
    styleUrls: ['signin.component.scss'],
    providers: [AuthService]
})
export class SigninComponent {
    customer: any = {
        password: "",
        email: "",
        pdv: ""
    }
    loader: boolean = false;
    step = 1;
    socialProvider = "";
    idToken = "";
    phone = "";
    constructor(
        private toastr: ToastrService,
        private webSiteUsersService: WebSiteUsersService,
        private pdvService: PdvService,
        private router: Router,
        private localStorage: localStorageService,
        public OAuth: AuthService
    ) {
        this.customer.pdv = this.pdvService.idPdv;
    }
    login() {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.customer.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
            this.loader = false;
        } else {
            if (this.customer.password.trim().length < 8) {
                this.toastr.error('Merci de saisir le mot de passe', 'Attention !');
                this.loader = false;
            } else {
                this.loader = true;
                this.webSiteUsersService.login({ email: this.customer.email, password: this.customer.password, pdv: this.customer.pdv }).subscribe(
                    (data: any) => {
                        this.localStorage.setItem({ key: 'token', value: data.token });
                        this.webSiteUsersService.listener.next(true);
                        this.router.navigate(['/']);
                    }, (err: any) => {
                        if (err.status == 400) {
                            this.loader = false;
                            if (err.error && err.error.indexOf('disabled') > -1) {
                                this.toastr.error('Votre compte a été désactivé par le restaurateur', 'Login');
                            } else {
                                this.toastr.error("l'adresse email ou mot de passe incorrect", 'Attention !');
                            }
                        }
                    }
                )
            }
        }
    }

    signIn(provider) {
        this.OAuth.signIn(provider).then(socialusers => {
            console.log(socialusers)
            this.socialProvider = provider;
            this.idToken = (provider=='facebook')?socialusers.token:socialusers.idToken;
            let clientId = (provider=='facebook')?PdvService.facebookId:PdvService.googleId;
            this.signInWithSocial({ clientId, provider, idToken: this.idToken })
        });
    }

    signInWithSocial(params) {
        this.webSiteUsersService.signInWithSocial(params).subscribe(
            (data: any) => {
                this.localStorage.setItem({ key: 'token', value: data.token });
                this.webSiteUsersService.listener.next(true);
                this.router.navigate(['/']);
            },
            (err: any) => {
                if (err.status == 400 && err.error.code == 1) {
                    this.step = 2;
                } else {
                    this.toastr.error('Code : ' + err.status, 'Erreur Serveur');
                }
            }
        )
    }

    back() {
        this.step = 1;
    }

    valide() {
        if (!this.phone.match(/^\d{10}$/)) {
            this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
            this.loader = false;
        } else {
            let clientId = (this.socialProvider=='facebook')?PdvService.facebookId:PdvService.googleId;
            this.signInWithSocial({ clientId, provider: this.socialProvider, idToken: this.idToken, phone: this.phone })
        }
    }
}
